import PropTypes from "prop-types";
import "./styles.scss";

const Letters = ({ text, size, isSentence = false, className = '' }) => {
  return text ? (
    <div className={["letters", size, isSentence ? "narrow" : "", className].join(" ").trim()}>
      {text}
    </div>
  ) : null;
};

Letters.propTypes = {
  text: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  isSentence: PropTypes.bool,
  className: PropTypes.string,
};

export default Letters;
